import React from 'react';
import { Link } from 'react-router-dom';
import SimpleModal from '../commons/modals/SimpleModal';
import QuantitySelector from '../commons/quantity-selector/QuantitySelector';
import ProductDefaultImage from '../../assets/images/product-default-image.jpg'
import CouponCode from '../commons/coupon/CouponCode';
import TipSelector from '../commons/tip-selector/TipSelector';

class BillDetailsMobile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      promoCodeModalVisibility: false
    }
    this.applyPromoCode = this.applyPromoCode.bind(this);
  }

  render() {
    const { billDetails, onChangeTipPercent, onChangeCustomTipValue, viewMode,
      onApplyCoupon, discountMessage, onRemoveCoupon } = this.props;
    const { promoCodeModalVisibility, promoCodeErrorMessage } = this.state;
    const discount = billDetails && billDetails.discount;

    return (
      <div className="bill-details-mobile">
        <div className="section-header">Price Details</div>
        <div className="bill-details-container">
          {billDetails.discountByPromoCode ? (
            <div className="bill-details-row">
              <div className="row-content">
                <div className="row-title">DISCOUNT<span className="row-hint">
                  {billDetails.discount && billDetails.discount.discountType == 1 ?
                    `FLAT $${billDetails.discountByPromoCode} OFF` :
                    `${billDetails.discount.discount * 100}% OFF`}
                </span></div>
              </div>
              <div className="row-content-right">
                <div className="row-title">${billDetails.discountByPromoCode.toFixed(2)}</div>
              </div>
            </div>
          ) : null}

          <div className="bill-details-row">
            <div className="row-content">
              <div className="row-title">CRV</div>
            </div>
            <div className="row-content-right">
              <div className="row-title">{billDetails && (billDetails.CRV || billDetails.CRV == 0)
                ? `$${billDetails.CRV.toFixed(2)}`
                : 'N/A'}</div>
            </div>
          </div>
          <div className="bill-details-row">
            <div className="row-content">
              <div className="row-title">SUBTOTAL</div>
            </div>
            <div className="row-content-right">
              <div className="row-title">{billDetails && billDetails.subTotal
                ? `$${billDetails.subTotal.toFixed(2)}`
                : 'N/A'}</div>
            </div>
          </div>
          <div className="bill-details-row">
            <div className="row-content">
              <div className="row-title">TAX</div>
            </div>
            <div className="row-content-right">
              <div className="row-title">{billDetails && billDetails.tax
                ? `$${parseFloat(billDetails.tax).toFixed(2)}`
                : 'N/A'}</div>
            </div>
          </div>
          <div className="bill-details-row">
            <div className="row-content">
              <div className="row-title">DELIVERY FEE</div>
            </div>
            <div className="row-content-right">
              <div className="row-title">{billDetails && billDetails.deliveryFee
                ? `$${billDetails.deliveryFee.toFixed(2)}`
                : 'N/A'}</div>
            </div>
          </div>
          <div className="bill-details-row tip-row">
            <div className="row-content">
              <div className="row-title">TIP</div>
              {viewMode && viewMode === 'edit'
                ? (<TipSelector percent={billDetails && billDetails.tip
                  ? billDetails.tip.percent
                  : 0} onChangeCustomValue={(v) => onChangeCustomTipValue(v)} onChangePercent={(p) => onChangeTipPercent(p)} />)
                : null}
            </div>
            <div className="row-content-right">
              <div className="row-title">{billDetails && (billDetails.tip || billDetails.tip == 0)
                ? `$${billDetails.tip.amount.toFixed(2)}`
                : 'N/A'}</div>
            </div>
          </div>

          {viewMode && viewMode === 'edit' ? discount && discount.code ? (
            <div className="bill-details-row promo-code-row has-promo-code footer">
              <div className="row-content" onClick={() => this.setState({ promoCodeModalVisibility: true })}>
                <div className="row-value">Promo Code</div>
                <div className="row-title">{discount.code}</div>
              </div>
              <div className="row-content-right">
                <button
                  type="button"
                  className="promo-remove-button"
                  onClick={() => onRemoveCoupon ? onRemoveCoupon(null, discount) : null}
                >
                  Remove
                </button>
              </div>
            </div>
          ) : (
              <div className="bill-details-row promo-code-row footer"
                onClick={() => this.setState({ promoCodeModalVisibility: true })}>
                <div className="row-content">
                  <div className="row-title">Apply Promo Code</div>
                </div>
                <div className="row-content-right">
                  <i className="fa fa-angle-right" />
                </div>
              </div>
            ) : null}

          <div className="bill-details-row footer">
            <div className="row-content">
              <div className="row-title">TOTAL</div>
            </div>
            <div className="row-content-right">
              <div className="row-title">{billDetails && billDetails.total
                ? `$${billDetails.total.toFixed(2)}`
                : 'N/A'}</div>
            </div>
          </div>
          <div className="promo-code-mobile">
            {billDetails && billDetails.discountByPromoCode ? (
              <span className="promo-discount">
                {"Hurray, you saved " +
                  `$${billDetails.discountByPromoCode.toFixed(2)}`}
              </span>
            ) : (
                ""
              )}
          </div>
        </div>

        {promoCodeModalVisibility ? (
          <SimpleModal title="Apply Promo Code"
            customClass="promo-code-modal"
            onCloseRequest={() => this.setState({ promoCodeModalVisibility: false })}>
            <div className="input-container">
              <input placeholder="Enter promo code" onChange={(e) => this.setState({ promoCode: e.target.value })} />
            </div>
            <div className="buttons-container">
              <div className="button button-dark-grey" onClick={() => this.setState({ promoCodeModalVisibility: false })}>Cancel</div>
              {promoCodeErrorMessage ? (
                <div><span className="text-danger">{discountMessage}</span></div>
              ) : null}
              <div className="button button-dark-grey" onClick={() => this.applyPromoCode()}>OK</div>
            </div>
          </SimpleModal>
        ) : null}
      </div>
    );
  }

  applyPromoCode() {
    const { promoCode, promoCodeErrorMessage } = this.state;
    const { onApplyCoupon } = this.props;

    if (!!onApplyCoupon) {
      onApplyCoupon(promoCode, (response) => {
        if (response.data) {
          this.setState({ promoCodeModalVisibility: false, promoCodeErrorMessage: false })
        } else {
          this.setState({ promoCodeErrorMessage: response.message })
        }
      })
    }
  }

}

export default BillDetailsMobile;



// WEBPACK FOOTER //
// ./src/components/cart/BillDetailsMobile.js